import React,{useEffect, useState} from 'react'
import { OverlayTrigger ,Tooltip} from 'react-bootstrap'
import { ButtonDropdown, DropdownMenu, DropdownToggle,  } from 'reactstrap'
import { CloseIcon, SwapGrayIcon, SwapIcon } from '../../../../assets/images';
import RadioContainer from '../../Radio/RadioContainer';
import { GSTR_SORTING_RADIO_OPTIONS } from '../../../../constant/tableHeadersConstants/gst';
import { RadioTypes } from '../../../../commonTypes/universalTypes';
import { GstRadioTypes } from '../../../../commonTypes/gstTypes';

type AppProps = {
    sorting:RadioTypes | undefined;
    setSorting:(data:RadioTypes | undefined)=>void;
    setOffset:(data:number)=>void;
    resetData:()=>void;
}

const GstSorting = ({
    sorting,
    setSorting,
    setOffset,
    resetData
}: AppProps) => {
    const [toggle, setToggle] = useState<boolean>(false);


    const handleSetInvoiceDateRadioValue = (radioValue: string) => {
      setOffset(0)
        let selectedOption=GSTR_SORTING_RADIO_OPTIONS?.find((item:GstRadioTypes)=>item.id==radioValue)
       setSorting(selectedOption)
    }

    useEffect(()=>{
      resetData()
    },[sorting])
    
   
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle)
      }}
    >
 <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 250 }}
           overlay={ <Tooltip id="button-view-filter-invoice">
           Sorting
        </Tooltip>}>
        
      <DropdownToggle
        caret
        color="secondary"
        style={toggle ? { color: "#dd4433",
        border: "1px solid #dd4433",
        backgroundColor: "#fff6f5"} : {border:"1px solid#bfcbe1"}}
        outline
      >
          <img src={toggle ? SwapIcon:SwapGrayIcon} alt="" />   
      </DropdownToggle>
          </OverlayTrigger>

      <DropdownMenu right>
         <div className="download-dropdown p-3" style={{minWidth:"300px"}}>

          <div className='d-flex justify-content-between align-items-center mt-0 mb-0'>
            <h5 className='text-center '>Sort By</h5>
            <div className='pointer' onClick={() => {
              setToggle(!toggle)
              }}>
              <img src={CloseIcon} alt="" />
            </div>

          </div> 
          <hr  className='mt-0 mb-0' />
        
        
          

          <div className='mt-2'>
            
            <div>
              <RadioContainer
                optionsList={GSTR_SORTING_RADIO_OPTIONS}
                handleSetRadioValue={handleSetInvoiceDateRadioValue}
                radioValue={sorting ? sorting?.id : ""}
                alignment="vertical"
                backGround={true}
              />
            </div> 
          </div>

        </div>

        
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default GstSorting